import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var body = designTokenFonts.body,
  bodyBold = designTokenFonts.bodyBold,
  heading = designTokenFonts.heading,
  subheading = designTokenFonts.subheading;
var colours = tokens.colors,
  spacing = tokens.spacing;
var enquiryForm = {
  name: "i9gxme",
  styles: "flex-grow:1;"
};
var header = {
  base: /*#__PURE__*/css("width:100%;", media('>=tablet'), "{padding-bottom:10px;}"),
  listing: /*#__PURE__*/css(media('>=tablet'), "{padding:10px;}"),
  watchlist: /*#__PURE__*/css(media('<tablet'), "{padding-bottom:10px;}", media('>=tablet'), "{padding-top:10px;}"),
  agent: /*#__PURE__*/css("padding-top:", spacing.s, ";", media('>=tablet'), "{padding:0;}")
};
var agentHeader = /*#__PURE__*/css("margin-top:", spacing.s, ";background-color:red;");
var logo = {
  name: "1hj7zjw",
  styles: "max-width:200px;max-height:70px;"
};
var sendCopyWrapper = {
  base: /*#__PURE__*/css("width:100%;padding:10px 0;", media('>=tablet'), "{padding:10px;}")
};
var title = {
  base: /*#__PURE__*/css(subheading, ";color:", colours.neutral.heavy.default, ";margin-bottom:12px;", media('>=tablet'), "{", heading, ";}"),
  listing: /*#__PURE__*/css(subheading, ";color:", colours.neutral.heavy.default, ";"),
  watchlist: self => self.listing
};
var sectionTitle = /*#__PURE__*/css(bodyBold, ";padding:10px 0;color:", colours.neutral.heavy.default, ";", media('>=tablet'), "{", subheading, ";}");
var buttonGroup = {
  base: /*#__PURE__*/css("width:100%;text-align:center;padding:10px 0;", media('>=tablet'), "{padding:10px;}.grecaptcha-badge{visibility:hidden;}"),
  appraisal: /*#__PURE__*/css("padding:0;", media('>=tablet'), "{padding:0;text-align:left;}")
};
var button = {
  base: /*#__PURE__*/css("display:inline-block;position:relative;min-width:100%;min-height:42px;max-height:42px;", bodyBold, ";text-align:center;"),
  agent: /*#__PURE__*/css(media('>=tablet'), "{min-width:192px;}"),
  listing: /*#__PURE__*/css("min-width:100%;", media('>=tablet'), "{max-width:500px;}"),
  watchlist: self => self.listing,
  appraisal: /*#__PURE__*/css(media('>=tablet'), "{min-width:192px;}")
};
var resetButtonGroup = /*#__PURE__*/css("width:100%;text-align:center;padding:10px;", media('>=tablet'), "{text-align:left;}");
var resetButton = /*#__PURE__*/css("display:inline-block;position:relative;width:100%;min-height:46px;max-height:46px;", bodyBold, ";text-align:center;", media('>=tablet'), "{width:260px;}");
var disclaimer = /*#__PURE__*/css("font-size:12px;line-height:1.33em;padding:10px 0;", media('>=tablet'), "{padding:10px;}a{text-decoration:none;color:", colours.neutral.medium.default, ";&:hover{text-decoration:underline;}}");
var table = {
  name: "1ymf3cs",
  styles: "display:table;width:100%;"
};
var row = {
  name: "ds3kc",
  styles: "display:table-row;"
};
var leftCol = {
  base: /*#__PURE__*/css("display:block;width:100%;padding:0;", media('>=desktop'), "{display:table-cell;width:50%;padding:0 10px 0 0;}"),
  watchlist: /*#__PURE__*/css(media('>=tablet'), "{display:table-cell;width:50%;padding:0 10px;}"),
  listing: /*#__PURE__*/css(media('>=tablet'), "{padding:0 10px;}")
};
var rightCol = {
  base: /*#__PURE__*/css("display:block;width:100%;padding:0;", media('>=desktop'), "{display:table-cell;width:50%;padding:0 0 0 10px;}"),
  watchlist: /*#__PURE__*/css(media('>=tablet'), "{padding:0 10px;}"),
  listing: /*#__PURE__*/css(media('>=tablet'), "{padding:0 10px;}")
};
var successMessageContainer = /*#__PURE__*/css("padding:10px;", media('>=tablet'), "{padding:10px 0;}");
var successMessage = /*#__PURE__*/css(body, ";color:", colours.neutral.heavy.default, ";text-align:left;margin-bottom:15px;padding-left:10px;");
var address = /*#__PURE__*/css(bodyBold, ";");
var checkboxColumns = {
  base: /*#__PURE__*/css("column-count:1;margin-bottom:10px;li{margin:10px 0;}li:first-of-type{margin-top:0;}", media('>=tablet'), "{column-count:2;padding-left:15px;}"),
  listing: /*#__PURE__*/css("column-count:2;margin-bottom:15px;padding-left:0;", media('>=tablet'), "{column-count:2;padding-left:10px;}li{margin:10px 0;}li:first-of-type{margin-top:0;}"),
  watchlist: self => /*#__PURE__*/css(self.listing, ";line-height:20px;")
};
var container = {
  base: /*#__PURE__*/css("background-color:", colours.neutral.surface.default, ";padding:32px;", media('<tablet'), "{padding:0 16px 16px 16px;}"),
  listing: /*#__PURE__*/css("width:100%;max-width:725px;background-color:", colours.neutral.subdued.default, ";", media('>=tablet'), "{padding:20px;}"),
  watchlist: self => /*#__PURE__*/css(self.listing, ";background-color:", colours.neutral.surface.default, ";", media('>=tablet'), "{padding-top:0;width:100%;}")
};
var promotionResetButtonGroup = /*#__PURE__*/css("width:100%;text-align:center;padding:10px 0;", media('>=tablet'), "{text-align:left;}");
var promotionSuccessMessage = /*#__PURE__*/css(body, ";color:", colours.neutral.heavy.default, ";text-align:left;margin-bottom:15px;");
var checkbox = /*#__PURE__*/css(".domain-checkbox__control-indicator{border:0.67px solid ", colours.neutral.heavy.default, ";}");
var separator = {
  base: {
    name: "1hyfx7x",
    styles: "display:none;"
  },
  appraisal: {
    name: "2f8187",
    styles: "display:block;padding:24px 0;"
  }
};
var addressAgents = {
  base: {
    name: "1hyfx7x",
    styles: "display:none;"
  },
  appraisal: /*#__PURE__*/css("display:flex;flex-direction:column;gap:", spacing.m, ";")
};
export default appearance => {
  var buildStyle = style => [style.base, typeof style[appearance] === 'function' ? style[appearance](style) : style[appearance]];
  return {
    enquiryForm,
    header: buildStyle(header),
    agentHeader: buildStyle(agentHeader),
    logo,
    sendCopyWrapper: buildStyle(sendCopyWrapper),
    sectionTitle,
    buttonGroup: buildStyle(buttonGroup),
    disclaimer,
    table,
    row,
    leftCol: buildStyle(leftCol),
    rightCol: buildStyle(rightCol),
    successMessage,
    successMessageContainer,
    title: buildStyle(title),
    button: buildStyle(button),
    checkboxColumns: buildStyle(checkboxColumns),
    container: buildStyle(container),
    resetButtonGroup,
    resetButton,
    address,
    promotionResetButtonGroup,
    promotionSuccessMessage,
    checkbox,
    separator: buildStyle(separator),
    addressAgents: buildStyle(addressAgents)
  };
};